import { useEffect, useState } from "react";
import "./ResponseDetailsScore.css";
import { FormResponseExtended, Question } from "effno-core";
import { Response } from "effno-core";

type ResponseDetailsScoreProps = {
    question: Question | null;
    responses: FormResponseExtended[] | null;
}

export const ResponseDetailsScore = ({question, responses} : ResponseDetailsScoreProps) => {

    let scores = 0;
    let scoreTotal = 0;

    const settings = question ? JSON.parse(question.settings) : {}

    const min = parseInt(settings.minScore) || 0;
    const max = parseInt(settings.maxScore) || 10; 

    const scoreArray : string [] = [];
    for (let i = min; i <= max; i++) {
        scoreArray.push(i.toString());
    }

    const responsesArray = new Array(scoreArray.length).fill(0);

    if (responses) {
        responses.forEach((formResponse: FormResponseExtended)  => {
            formResponse.responses.forEach((response: Response) => {
                if (response.questionId === question?.id) {
                    const responseValues = JSON.parse(response.responseValues);
                    const score = responseValues.score;

                    if (score) {
                        const index = scoreArray.indexOf(score.toString());

                        if (index !== -1) {
                            responsesArray[index] += 1;
                            scores++;
                            scoreTotal += score;
                        }
                    }

                }

            })
        });
    }

    const avgScore = scores > 0 ? (scoreTotal / scores).toFixed(1) : 0;

    console.log("[ResponseDetailsRating] scoreArray: ", scoreArray);
    console.log("[ResponseDetailsRating] responsesArray: ", responsesArray);

    return (
        <div className="response-details-score">
            <div className="response-details-score-header">
                <div className="response-details-generic-stat">
                    Scores: {scores}
                </div>
                <div className="response-details-generic-stat">
                    Average Score: {avgScore}
                </div>
            </div>

            <div className="response-details-score-scores">
                {scoreArray.map((score, index) => {
                    const percentage = Math.floor((responsesArray[index] / scores) * 100);
                    return (
                        <div className="response-details-score-entry">
                            <div className="response-details-score-value">
                                {score}
                            </div>
                            <div className="response-details-score-bar-container">
                                <div 
                                    className="response-details-score-bar-value"
                                    style={{width: `${percentage}%`}}
                                >
                                    {}
                                </div>
                            </div>
                            <div className="response-details-score-bar-responses">
                                {responsesArray[index]} responses
                            </div>

                        </div>
                    )
                })}
            </div>
        </div>
    )
}